import React, { useEffect } from "react";
import useForm from "../../../../hooks/useForm";
import Form from "../../../form/Form";
import Select from "../../../form/select/Select";
import Input from "../../../form/Input";
import Button from "../../../form/Button";
import Tooltip from "../../../elements/Tooltip";
import Checkbox from "../../../form/Checkbox";
import Radio from "../../../form/Radio";
import FileUploadSingle from "../../../form/FileUploadSingle";
import { Draggable } from "react-beautiful-dnd";
import GridForm from "./GridForm";

const AddForms = ({
  form,
  onSave = () => {},
  addMoreHandler = () => {},
  copyHandler = () => {},
  onRemove = () => {},
  removeable = true,
  index,
  id,
}) => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm();

  useEffect(() => {
    setFieldsValue(form);
  }, [form]);

  useEffect(() => {
    onSave(values);
  }, [JSON.stringify(values)]);

  function onchangeHandler(val) {
    if (["Dropdown", "Checkbox", "Radio"].includes(val)) {
      const updatedOptions = [
        {
          label: "",
          value: "",
          ...((val === "Checkbox" || val === "Radio") && {
            checked: false,
          }),
        },
        {
          label: "",
          value: "",
          ...((val === "Checkbox" || val === "Radio") && {
            checked: false,
          }),
        },
        {
          label: "",
          value: "",
          ...((val === "Checkbox" || val === "Radio") && {
            checked: true,
          }),
        },
      ];
      setFieldsValue({
        ...values,
        fieldType: val,
        options: updatedOptions,
      });
    } else if (val === "mcqGrid") {
      setFieldsValue({
        ...values,
        fieldType: val,
        options: {
          rows: [
            { label: "rows 1", value: "1" },
            { label: "rows 2", value: "2" },
          ],
          columns: [
            { label: "cols 1", value: "1" },
            { label: "cols 2", value: "2" },
          ],
        },
      });
    } else {
      const { options, ...rest } = values;
      setFieldsValue({ ...rest, fieldType: val });
    }
  }

  return (
    <Draggable
      key={index.toString()}
      draggableId={form?._id || index.toString()}
      index={index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`${snapshot.isDragging ? "" : ""}`}
        >
          <Form
            onSubmit={(val) => {
              onSave(val);
            }}
            handleSubmit={handleSubmit}
          >
            <div className="bg-white p-10 rounded-xl space-y-8 relative">
              <div
                {...provided.dragHandleProps}
                className="flex items-center justify-center p-3 absolute w-full top-0 left-0"
              >
                <i className="fa-fw fa-solid fa-grip-dots text-gray-400"></i>
              </div>
              <div className="grid grid-cols-12 gap-5 w-full ">
                <div className="grid grid-cols-4 col-span-11 gap-5">
                  <Select
                    label="Field Type"
                    placeholder="Type"
                    selectedValue={values?.fieldType}
                    dropdownData={[
                      { name: "Input", value: "Input" },
                      { name: "Email", value: "Email" },
                      { name: "Text area", value: "TextArea" },
                      { name: "Input number", value: "InputNumber" },
                      { name: "Url", value: "Url" },
                      { name: "Date picker", value: "DatePicker" },
                      { name: "Dropdown", value: "Dropdown" },
                      { name: "Multiple choice grid", value: "mcqGrid" },
                      { name: "Checkbox grid", value: "checkboxGrid" },
                      { name: "Radio", value: "Radio" },
                      { name: "Checkbox", value: "Checkbox" },
                      { name: "File", value: "File" },
                    ]}
                    onChange={(val) => {
                      onchangeHandler(val);
                    }}
                  />

                  <FileUploadSingle size="small" label={"Upload image"} />

                  <Input
                    label="Label"
                    inputPlaceholder="Field Label"
                    value={values?.label}
                    onChange={handleChange}
                    inputName="label"
                    isDisabled={
                      values?.fieldType === "Radio" ||
                      values?.fieldType === "Checkbox"
                    }
                  />

                  <Input
                    label="Placeholder"
                    inputPlaceholder="Enter placeholder"
                    value={values?.placeholder}
                    onChange={handleChange}
                    inputName={"placeholder"}
                    isDisabled={
                      values?.fieldType === "Radio" ||
                      values?.fieldType === "Checkbox"
                    }
                  />
                </div>

                <div className="col-span-1">
                  <Select
                    label="Required*"
                    placeholder="Dropdown"
                    selectedValue={values?.isRequired}
                    dropdownData={[
                      { name: "Yes", value: true },
                      { name: "No", value: false },
                    ]}
                    onChange={(val) => {
                      handleChange({
                        target: { name: "isRequired", value: val },
                      });
                    }}
                  />
                </div>
              </div>
              {["Dropdown", "Checkbox", "Radio"].includes(
                values?.fieldType
              ) && (
                <div className="flex flex-col space-y-4">
                  <ul className="grid grid-cols-3 gap-3">
                    {values?.options?.map((opt, i) => (
                      <li
                        key={i?.toString()}
                        className="flex gap-2 items-center bg-slate-50 rounded-lg p-4 justify-between"
                      >
                        <div className="space-y-2">
                          <div className="flex items-center gap-3 flex-grow">
                            {["Checkbox", "Radio"].includes(
                              values?.fieldType
                            ) && (
                              <span className="mt-4">
                                {values?.fieldType === "Radio" ? (
                                  <Radio
                                    radioName={id?.toString()}
                                    isChecked={opt?.checked}
                                    onChange={(e) => {
                                      setFieldsValue({
                                        options: values?.options?.map(
                                          (item, index) =>
                                            i === index
                                              ? {
                                                  ...item,
                                                  checked: e.target.checked,
                                                }
                                              : { ...item, checked: false }
                                        ),
                                      });
                                    }}
                                  />
                                ) : (
                                  <Checkbox
                                    checked={opt?.checked}
                                    onChange={(e) => {
                                      setFieldsValue({
                                        options: values?.options?.map(
                                          (item, index) =>
                                            i === index
                                              ? {
                                                  ...item,
                                                  checked: e.target.checked,
                                                }
                                              : item
                                        ),
                                      });
                                    }}
                                  />
                                )}
                              </span>
                            )}
                            <Input
                              label={`Option ${i + 1}`}
                              inputPlaceholder={"Enter option"}
                            />
                          </div>
                          <FileUploadSingle size="small" />
                        </div>
                        <Button
                          buttonIcon={"fa-regular fa-trash-can"}
                          buttonClasses={
                            "p-0 mt-4 w-10 !bg-transparent !text-primary hover:!opacity-60s"
                          }
                          buttonFunction={() => {
                            setFieldsValue({
                              ...values,
                              options: values?.options?.filter(
                                (item, j) => j !== i
                              ),
                            });
                          }}
                        />
                      </li>
                    ))}
                  </ul>
                  <Tooltip
                    message={"Add more option"}
                    position="top"
                    className={"ml-auto"}
                  >
                    <Button
                      buttonIcon={"fa-regular fa-plus"}
                      buttonType="button"
                      buttonFunction={() => {
                        setFieldsValue({
                          options: [
                            ...(values?.options || []),
                            {
                              label: "",
                              value: "",
                              ...(["Checkbox", "Radio"].includes(
                                values?.fieldType
                              ) && { checked: false }),
                            },
                          ],
                        });
                      }}
                    />
                  </Tooltip>
                </div>
              )}
              {["mcqGrid", "checkboxGrid"].includes(values?.fieldType) && (
                <GridForm data={values} setData={setFieldsValue} />
              )}
              <div className="h-10 border-t border-slate-200 py-4 flex justify-end gap-2">
                <Button
                  buttonLabel="Save"
                  buttonType="submit"
                  buttonClasses="!rounded !px-8 !h-10 !bg-chestnut-rose !text-white"
                />
                <Tooltip message={"Reset fields"} position="top">
                  <Button
                    buttonIcon={"fa-regular fa-undo"}
                    buttonType="button"
                    buttonFunction={() => {
                      setFieldsValue({
                        fieldType: "",
                        label: "",
                        placeholder: "",
                        isRequired: false,
                      });
                    }}
                  />
                </Tooltip>
                <Tooltip message={"Copy form"} position="top">
                  <Button
                    buttonIcon={"fa-regular fa-copy"}
                    buttonFunction={() => {
                      copyHandler(values, id);
                    }}
                  />
                </Tooltip>
                {removeable && (
                  <Tooltip message={"Delete form"} position="top">
                    <Button
                      buttonIcon={"fa-regular fa-trash-can"}
                      buttonFunction={() => {
                        onRemove(id);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          </Form>
        </div>
      )}
    </Draggable>
  );
};

export default AddForms;
